import React from 'react';
import { opsteamuser } from './Datatype';

interface props {
  teamdata: opsteamuser[];
  openedit: (item: opsteamuser) => void;
  deletemember: (item: opsteamuser) => void;
}

const MasterTable: React.FC<props> = ({ teamdata, openedit, changeuserstatus }) => {
  const rows = teamdata.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select 
          className="action-select" 
          value="" 
          onChange={(e) => {
            e.target.value === "edit" && openedit(item);
            e.target.value === "changestatusinactive" && changeuserstatus(item, "inactive");
            e.target.value === "changestatusactive" && changeuserstatus(item, "active");

          }}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
          <option value="changestatusinactive">set status: inactive</option>
          <option value="changestatusactive">set status: active</option>

        </select>
      </td>
      <td><strong>{item.email}</strong></td>
      <td>
        <span className="badge badge-green">
          {item.usertype}
        </span>
      </td>
      <td>{item.status}</td>

    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>email</th>
          <th>role</th>
          <th>status</th>

        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={3} style={{ textAlign: 'center', padding: '16px' }}>No ops users found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default MasterTable;